<template>
  <div>
    <OnboardingImageSection
      width="100%"
      :image="accountsStructureExample"
      align="center"
    />

    <OnboardingTextSection>
      Аккаунты объединяют данные из разных<br>
      рекламных площадок и позволяют безопасно дать<br>
      доступ в систему как коллегам, так и клиентам.
    </OnboardingTextSection>

    <OnboardingTextSection>
      Основное отличие МСС-аккаунта от Стандартного<br>
      в том, что <b>Стандартный аккаунт</b> всегда является<br>
      <b>последним</b> в цепочке аккаунтов и только в нем<br>
      можно создавать <b>проекты</b>
    </OnboardingTextSection>
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';
  import OnboardingImageSection from 'onboarding/onboardings/components/OnboardingImageSection';
  import accountsStructureExample from 'onboarding/onboardings/AccountsListOnboarding/assets/account-structure-example.png';

  export default {
    name: 'AccountTypesExampleStep',
    components: {OnboardingImageSection, OnboardingTextSection},
    data () {
      return {
        accountsStructureExample
      };
    }
  };
</script>
